import styles from './index.module.scss';
import EcoSpace from 'eco-design/base/eco-space';
import EcoButton from 'eco-design/base/eco-button';
import getLocal from '@/app/utils/getLocal';
import { useEffect, useState } from 'react';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import EcoImg from 'eco-design/base/eco-img';

type IProps = {
    id: string;
    title: string;
    desc: string;
    imglist: { title?: string; desc?: string; img: string; imgh5: string }[];
    productlist: { img: string; title: string; desc: string; learnmore: string; buylink: string; price?: number; compareAtPrice?: number }[];
};

const D3USerues: React.FC<IProps> = ({ id, title, desc, imglist, productlist }) => {
    const { locale } = getLocal();
    const [show, setShow] = useState(false);

    let interObserver: IntersectionObserver | null;
    useEffect(() => {
        const apperCb: IntersectionObserverCallback = (params: IntersectionObserverEntry[]) => {
            const data = params[0];
            const calIconStatus = data.intersectionRatio > 0.1;
            calIconStatus && setShow(calIconStatus);
        };
        interObserver && interObserver.disconnect();
        interObserver = new IntersectionObserver(apperCb, {
            threshold: [0.1], // 触发阈值（10%）
        });

        const div = document.querySelector(`#${id}`);
        if (div) {
            interObserver.observe(div as HTMLElement);
        }

        return () => {
            interObserver && interObserver.disconnect();
        };
    }, []);

    return (
        <div className={`${styles.D3Serues} eco-content ${show ? 'show' : ''} GtmModuleData-section`} id={id} data-section-id={id}>
            <EcoSpace />
            <h3 className="d3_title fade-in" style={{ animationDelay: '200ms' }}>
                {title}
            </h3>
            <p className="d3_subtitle fade-in" style={{ animationDelay: '400ms' }}>
                {desc}
            </p>
            <div className="content">
                {imglist.map((item, index) => (
                    <div key={index} className="img-item fade-in" style={{ animationDelay: `${200 * (index + 3)}ms` }}>
                        <EcoImg isOpenLazy pc={item.img} h5={item.imgh5} />
                        <div className="imgtext">
                            <h6 className="imgtext-title">{item.title}</h6>
                            <h6 className="imgtext-desc">{item.desc}</h6>
                        </div>
                    </div>
                ))}
                <div className="product-box">
                    {productlist.map((item, index) => (
                        <div key={index} className="product-item fade-in" style={{ animationDelay: `${200 * (index + 8)}ms` }}>
                            <EcoImg isOpenLazy pc={item.img} />
                            <div className="product-text">
                                <p className="product-title">{item.title}</p>
                                <p className="product-desc">{item.desc}</p>
                                <p className="product-price">
                                    <span className="price">{FormatMoneyLocal((item.price || 0).toFixed(2), locale)}</span>
                                    {item.compareAtPrice && (
                                        <span className="comparprice">{FormatMoneyLocal((item.compareAtPrice || 0).toFixed(2), locale)}</span>
                                    )}
                                </p>
                                <div className="product-tools">
                                    <div className="out-btn">
                                        <EcoButton
                                            className="shop-now GtmModuleData-btn-href"
                                            lChildren="Shop Now"
                                            lHref={item.buylink}
                                            lType="filled"
                                            lRadius="ellipse"
                                            lDataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'buy',
                                                product_name: item?.title,
                                                position: `delta-3-series_Shop Now_${title}`,
                                                __btn_id1: `${styles.D3Serues} .shop-now`,
                                                __btn_id2: item.buylink,
                                                __btn_type: 'href',
                                            }}
                                        />
                                    </div>
                                    <EcoButton
                                        className="learn-more GtmModuleData-btn-href"
                                        lChildren="Learn More"
                                        lHref={`/${locale}${item.learnmore}`}
                                        lType="outlined"
                                        lRadius="ellipse"
                                        lTheme="white"
                                        lDataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'select_product',
                                            list_name: title,
                                            product_name: item?.title,
                                            button_name: 'Learn More',
                                            __btn_id1: `${styles.D3Serues} .learn-more`,
                                            __btn_id2: `/${locale}${item.learnmore}`,
                                            __btn_type: 'href',
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default D3USerues;
